import { useTranslation } from "react-i18next";
import { ConfirmationModal } from "src/components/Modals/ConfirmationModals/ConfirmationModal";
import { useResetSection } from "src/hooks/useCourses";

interface RegenerateSectionConfirmationModalProps {
	onClose: () => void;
	sectionId: string;
	courseId: string;
}

export const RegenerateSectionConfirmationModal = ({
	onClose,
	sectionId,
	courseId,
}: RegenerateSectionConfirmationModalProps) => {
	const { t } = useTranslation();
	const { mutateAsync: resetSection, isPending: isLoading } =
		useResetSection() as unknown as {
			mutateAsync: (payload: {
				sectionId: string;
				courseId: string;
			}) => Promise<void>;
			isPending: boolean;
		};

	const onConfirm = async () => {
		await resetSection({
			sectionId: sectionId,
			courseId,
		});
	};

	return (
		<ConfirmationModal
			title={t("modals.confirm.regenerateCourseSection.title")}
			onConfirm={onConfirm}
			onClose={onClose}
			isLoading={isLoading}
		>
			<p className="m-0 text-center">
				{t("modals.confirm.regenerateCourseSection.subtitle")}
			</p>
		</ConfirmationModal>
	);
};
